import { getSubmissionFields } from "../utils";
import Form from "./Form";
import { useDataContext, useUserContext } from "../contexts";

export default function SubmissionEdit({ callback, submission }) {
  const { user } = useUserContext();
  const { memberUsers } = useDataContext();

  const submissionFields = getSubmissionFields(memberUsers, user);

  return (
    <Form
      path="submissions"
      id={submission.id}
      method="PATCH"
      submitCallback={callback}
      initialValues={submission}
      fields={submissionFields}
    />
  );
}
